import { render, staticRenderFns } from "./questionAnalyze.vue?vue&type=template&id=0d5de0d2&scoped=true&"
import script from "./questionAnalyze.vue?vue&type=script&lang=js&"
export * from "./questionAnalyze.vue?vue&type=script&lang=js&"
import style0 from "./questionAnalyze.vue?vue&type=style&index=0&id=0d5de0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5de0d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDialog,VImg})
